<template>
  <el-dialog
    :title="title"
    :visible.sync="centerDialogVisible"
    center
    @opened="openedEnd"
    @closed="reset"
  >
    <div class="scanCode">
      <span class="text">{{ qrCode64 ? second === 0 ? '请刷新二维码' : second : '加载中...' }}</span>
      <div
        v-loading="loading"
        class="code64"
        style="text-align: center;width: 181px; height: 177px; position: relative;overflow: hidden;margin-bottom: 18px;"
      ><!--width: 181px; height: 177px; position: relative;overflow: hidden;margin-bottom: 18px; -->
        <img :src="qrCode64" style="position: relative;" :style="{...myobj}">
        <!-- style="position: relative;left: -155px;top: -143px; width: 269%;" -->
        <div v-if="mantle" class="mantle" />
      </div>
      <div style="margin: 5px 0px;">
        <span>请在30秒内扫描二维码</span>
        <el-button type="primary" style="margin-left:10px" @click="refresh">刷新二维码</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    myobj: {
      type: Object,
      default() {
        return {

        }
      }
    },
    title: {
      type: String,
      default: '扫码登录'
    }
  },
  data() {
    return {
      centerDialogVisible: false,
      loading: false,
      qrCode64: null,
      second: 30,
      ident: null,
      mantle: null
    }
  },
  methods: {
    open(obj = {}) {
      this.title = obj.title || this.title
      this.second = 30
      this.loading = true
      this.mantle = false
      this.qrCode64 = null
      this.centerDialogVisible = true
    },
    openedEnd() {
      clearTimeout(this.ident)
      this.open()
      this.$emit('openedEnd', (qrCodeSrc) => {
        if (qrCodeSrc === 'err') {
          this.loading = false
          this.qrCode64 = true
          this.mantle = true
          this.second = 0
        } else {
          this.qrCode64 = qrCodeSrc
          this.loading = false
          this.ident = setInterval(() => {
            this.second = this.second - 1
            if (this.second <= 0) {
              clearInterval(this.ident)
              this.mantle = true
            }
          }, 1000)
        }
      })
    },
    reset() {
      this.$emit('reset', () => {
        clearTimeout(this.ident)
        this.loading = false
        this.centerDialogVisible = false
        this.qrCode64 = null
        this.second = 30
        this.ident = null
      })
    },
    refresh() {
      if (this.loading) {
        this.$message({
          message: '请求中。。。',
          type: 'warning'
        })
        return
      }

      this.loading = true
      this.qrCode64 = null
      this.second = 30
      this.mantle = false
      this.openedEnd()
    }
  }
}
</script>

<style scoped lang="less">
.scanCode{
    display: flex;
    flex-direction: column;
    align-items: center;
    .text{
     display: inline-block;
    margin: 10px 0px;
    font-size: 21px;
    font-weight: bold;
    }
  .code64 {
      width: 520px;
      height: 337px;
      position: relative;
      .mantle{
         position: absolute;
         width: 100%;
         height: 100%;
         background-color: #ccc;
         top: 0px;
         .clonse{
           position: absolute;
           width: 25px;
           height: 25px;
           border-radius: 50%;
           background-color: #ccc;
           font-style: normal;
           right: 6px;
           top: 6px;
           display: flex;
           justify-content: center;
           align-items: center;
           font-weight: bold;
           cursor: pointer;
         }
      }
  }
}
</style>
